const EN = {
  // Currency
  currency: "SAR",

  // Buttons Labels Repeated
  "modal-ok-btn": "OK",
  "send-btn": "Send",
  "cancel-btn": "Cancel",

  // ==========================================================================================================================================
  // Error Messages
  "phone-number-error": "Please enter a phone number",
  "password-error": "Please enter your password",
  "confirm-password-error": "Please confirm the password",
  "user-name-error": "Please enter your username",
  "confirm-code-error": "Please enter the code",

  // Input Error Messages
  "user-name-input-error": "Please ensure that the entered username is correct",
  "phone-number-input-error":
    "Please make sure that the entered phone number is correct",
  "password-input-error":
    "Please make sure that the password entered is correct",
  "confirm-password-input-error": "Please confirm the password correctly",
  // ==========================================================================================================================================
  // Navbar
  "arabic-key": "Arabic",
  "english-key": "English",
  "urdu-key": "Urdu",
  "hindi-key": "Hindi",
  "main-tab": "Main",
  "notification-tab": "Notification",
  "orders-tab": "Track Orders",
  "settings-tab": "Settings",
  "user-name": "User Name",
  "sign-out": "Sign Out",
  // ==========================================================================================================================================
  // StartUp
  "Startup-form-header": "Clean Up your stuff",
  "Startup-box-text-1": "Have a lot of things that need cleaning?",
  "Startup-box-text-2": "Relax and call us to CLEAN everything you need",
  "Startup-box-text-3": "What are you waiting for? Join Us now",
  "Lets-start-btn": "Let's Start !",

  // Copy Rights Start
  "copy-rights-start-1": "Have any question?",
  "copy-rights-start-2": "Contact Us",
  "copy-rights-start-3": "Cleaning Services App",
  "copy-rights-start-4": "| All Rights Reserved",
  "copy-rights-start-5": "Developed by Stack Soft Company",

  // ==========================================================================================================================================
  // LogIn
  "login-form-header": "Log In",
  "login-phone-number-label": "Phone Number",
  "login-phone-number-text":
    "We'll never share your phone number with anyone else.",
  "login-phone-number-placeholder": "Phone Number",
  "login-password-label": "Password",
  "login-password-placeholder": "Password",
  "login-btn-text": "Log In",
  "login-no-account-text": "Don't have an account yet?",
  "login-no-account-signup": "Sign up",
  "login-method-text": "Or Log In with",
  "login-method-1-text": "Google",
  "login-method-2-text": "Apple",

  // ==========================================================================================================================================
  // SignUp
  "signup-form-header": "Sign Up",
  "confirm-signup-form-header": "verification step",
  "confirm-signup-please-input-code": "Please insert the confirm code",
  "confirm-signup-code-is-sent-to": "The code is sent to: ",
  "confirm-signup-ask-if-receive-code": "Didn't receive the code? ",
  "confirm-signup-re-send-code": "Resend",
  "confirm-signup-verify-code": "Confirm",
  "confirm-signup-close-code": "Back",
  "signup-phone-number-text":
    "We'll never share your phone number with anyone else.",
  "signup-phone-number-placeholder": "Phone Number",
  "signup-user-name-placeholder": "Username",
  "building-number": "Building No.",
  "floor-number": "Floor No.",
  "signup-password-placeholder": "Password",
  "signup-password-confirm-placeholder": "Confirm Password",
  "signup-btn-text": "Sign Up",
  "signup-method-text": "Or Sign Up with",
  "signup-method-1-text": "Google",
  "signup-method-2-text": "Apple",

  // ==========================================================================================================================================
  // Main
  // Main Navbar
  "search-main-tab": "Find a laundromat",
  "fav-main-tab": "Favorite",
  "recently-main-tab": "Recently Used",
  "request-main-tab": "Service Request",

  // ==========================================================================================================================================
  // Search Washer
  "Search-box-placeholder": "Search by name...",
  "laundry-location-label-card": "Laundromat Location: ",
  "rate-filter-search-washer": "most rated",
  "near-filter-search-washer": "nearest",
  "rate-max-to-min": "From most rated to least",
  "rate-min-to-max": "From least rated to most",
  "choose-city": "Choose City",
  "sort-starting-with": "Sort from",
  "discount-label": "Discount",
  "free-deliver-label": "Free Deliver",
  "no-laundromats": "There are no laundries yet",

  // ==========================================================================================================================================
  // Laundry Modal
  "laundry-services-label": "Laundromat Services: ",
  "request-service-button": "Service Request",
  "move-to-map-button": "Move to map",
  "services-laundry-table-column": "Services Provided",
  "size-laundry-table-column": "Serving Size",

  // ==========================================================================================================================================
  // Service Request
  "choose-type": "Choose a type",
  "choose-type-first": "Choose item type first",
  "check-box-take-your-order":
    "Taking your order and returning it to you through the delivery representatives",
  "choose=service-type-select-option": "Choose the type of service",
  "send-request-service": "Send Request",
  "specify-current-location": "Select your current location:",
  "span-under-location-row":
    "Your current location coordinates will be taken automatically to facilitate the customer's access to you*",
  "no-services-yet": "There are no other services",
  "price-after-discount": "Price after discount:",
  "price-after-free-delivery": "Price after deducting delivery fee:",

  // ==========================================================================================================================================
  // Settings
  // Settings Navbar
  "password-settings-tab": "Password",
  "user-info-settings-tab": "User Info",
  "location-settings-tab": "Location",
  "Terms-Conditions-settings-tab": "Terms and Conditions",
  "system-work-settings-tab": "System Work",
  // ==========================================================================================================================================
  // System Change Password
  "system-user-name-change-label": "User Name",
  "system-phone-change-label": "Phone Number",
  "system-old-password-change-label": "Old Password",
  "system-password-change-label": "New Password",
  "system-confirm-password-change-label": "Confirm New Password",
  "system-password-btn-change-label": "Confirm",
  // ==========================================================================================================================================
  // System Change Location
  "system-location-change-label": "Your current location",
  "system-location-change-note":
    "If you set the location manually, please specify it accurately",
  "system-location-btn-auto-label": "Set the location automatically",
  "system-location-btn-change-label": "Confirm",
  // ==========================================================================================================================================
  // System Work
  Bronze: "Bronze",
  Silver: "Silver",
  Gold: "Gold",
  Diamond: "Diamond",

  // ==========================================================================================================================================
  // Notifications
  // Notifications Texts
  "Laundry-Accept": "Your laundry order has been accepted",
  "Laundry-Reject": "Your laundry order has been refused",
  "Delivery-Accept": "Your request has been received from the delivery",
  "Laundry-Received-order":
    "Your order has arrived at the laundromat and we'll let you know when it's done",
  "Laundry-start-washing-notification": "Your order details are",
  "Laundry-finish-washing-ready-Delivering": "Your request has been completed",
  "Free-Delivery-notif": "",
  "Discount-notif": "",
  "Delivered-state": "Your request has been delivered successfully",
  "order-num-notification": "Order Number: ",
  "rate-send-notification": "How was your experience? ",
  "note-send-notification": "What are your feedback? ",

  // Notifications Table details
  "item-type-column-notification": "Item Type",
  "service-type-column-notification": "Service Type",
  "number-of-items-column-notification": "Number of Items",
  "price-column-notification": "Price",

  // ==========================================================================================================================================
  // Orders
  // Orders Navbar
  "my-orders-nav": "My Orders",
  "done-orders-nav": "My Finished Orders",

  // Order Statuses
  "Waiting-Laundry-Accept": "Pending Laundry Acceptance",
  "Waiting-Delivery-Accept": "Pending deliveryman reception acceptance",
  "Delivery-Taking-Order-from-user": "Being brought from client",
  "Delivery-Taking-Order-to-Laundry": "Being brought to laundry",
  "Waiting-Laundry-start-washing": "Pre-processing",
  "Laundry-start-washing": "Processing",
  "Ready-to-Deliver": "Ready to be deliver",
  "Waiting-Delivery-Taking-Accept": "Pending deliveryman deliver acceptance",
  "Delivery-ReturnBack-Order-from-Laundry": "Being brought from laundry",
  "Delivery-ReturnBack-Order-to-user": "Being brought to client",
  "Delivered-order-to-user": "Done",

  // Order Labels
  "Laundry-name-label-order": "Laundromat name: ",
  "Delivery-name-label-order": "Delivery name: ",
  "Date-label-order": "Date Creation: ",
  "Type-label-order": "Order Type: ",
  "details-name-btn-order": "Order details",

  // Order Details Modal and Table
  "item-type-column": "Item Type",
  "service-type-column": "Service Type",
  "number-of-items-column": "Number of Items",
  "price-column": "Price",
  "price-label-modal": "Total Price: ",
  "price-cost-label-modal": "Cost: ",
  "price-commission-label-modal": "Commission: ",

  // delivering Orders Types
  "delivery-two-ways": "It is taken and given by deliverymen",
  "delivery-one-way": "Taken by deliverymen only",

  // ==========================================================================================================================================

  // Contact Us

  // ******  Headers
  "contactUs-header": "Contact Us",
  "first-contactUs-header": "Contact Information",
  "second-contactUs-header": "Leave Us a message",

  // ******  Communicate Column
  "location-communicate-label": "Address",
  "location-communicate-value": "Jordan Jordan Jordan",
  "phone-communicate-label": "Phone",
  "phone-communicate-value": "0999999999",
  "email-communicate-label": "E-mail Address",
  "email-communicate-value": "example@gmail.com",

  // ******  send message Column
  "name-label": "Name",
  "name-placeholder": "your name",
  "email-send-message-label": "E-mail Address",
  "email-send-message-placeholder": "example@gmail.com",
  "message-contactUs-label": "Message",
  "message-contactUs-placeholder": "what do you want to tell us ?",
  "button-send-message-contactUs": "Send",

  // ==========================================================================================================================================
};

export default EN;
